/* force-push-1780833264183313000 */
/* Pooches Pantry — interaction layer
   - Scroll reveals (IntersectionObserver)
   - Quick-add to cart (no page reload)
   - Cart drawer ping after add
*/
(function () {
  'use strict';

  // ─── Scroll reveal ─────────────────────────────────────────────
  function setupReveals() {
    var els = document.querySelectorAll('[data-pp-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.04 });
    els.forEach(function (el) { io.observe(el); });
  }

  // ─── Quick add to cart (Dawn-compatible Section Rendering API) ─
  function setupQuickAdd() {
    document.body.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('[data-pp-quickadd]')) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn && btn.disabled) return;

      var formData = new FormData(form);
      // Ask Shopify to render these sections in the cart/add response
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);

      if (btn) { btn.disabled = true; btn.classList.add('is-adding'); }

      fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (btn) {
            btn.classList.remove('is-adding');
            btn.classList.add('is-added');
            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.disabled = false;
            }, 1400);
          }

          if (json && json.status && json.status >= 400) {
            // Add failed (e.g. out of stock) — surface error
            console.warn('Cart add failed:', json.description || json.message);
            return;
          }

          if (json && json.sections) {
            // 1. Replace cart-drawer section contents
            if (json.sections['cart-drawer']) {
              var drawer = document.querySelector('cart-drawer');
              if (drawer) {
                var tmp = document.createElement('div');
                tmp.innerHTML = json.sections['cart-drawer'];
                var newDrawer = tmp.querySelector('cart-drawer');
                if (newDrawer) {
                  // Preserve outer custom-element bindings, swap inner HTML only
                  drawer.innerHTML = newDrawer.innerHTML;
                  drawer.classList.remove('is-empty');
                }
                // Open the drawer (Dawn's CartDrawer.open binds backdrop + focus)
                if (typeof drawer.open === 'function') {
                  drawer.open();
                } else {
                  drawer.classList.add('animate', 'active');
                  drawer.removeAttribute('inert');
                  document.body.classList.add('overflow-hidden');
                }
              }
            }
            // 2. Replace cart-icon-bubble section contents
            if (json.sections['cart-icon-bubble']) {
              var bubble = document.getElementById('cart-icon-bubble');
              if (bubble) {
                var b = document.createElement('div');
                b.innerHTML = json.sections['cart-icon-bubble'];
                var inner = b.querySelector('.shopify-section') || b.firstElementChild;
                if (inner) bubble.innerHTML = inner.innerHTML;
              }
            }
          }

          // 3. Update PP custom cart-count badges + dispatch event
          return fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('[data-pp-cart-count]').forEach(function (el) {
                el.textContent = cart.item_count;
              });
              document.dispatchEvent(new CustomEvent('cart:item-added', { detail: cart }));
            });
        })
        .catch(function (err) {
          console.error('PP quickadd error', err);
          if (btn) { btn.disabled = false; btn.classList.remove('is-adding'); }
        });
    });
  }

  // ─── Auto-reveal on common section heads + cards ──────────────
  function autoTagReveals() {
    var selectors = [
      '.pp-section__head',
      '.pp-card',
      '.pp-bundle',
      '.pp-step',
      '.pp-card-tile',
      '.pp-promise__item',
      '.pp-testimonial',
      '.pp-feature-pill'
    ];
    var nodes = document.querySelectorAll(selectors.join(','));
    nodes.forEach(function (n) {
      if (!n.hasAttribute('data-pp-reveal')) {
        n.setAttribute('data-pp-reveal', '');
      }
    });
  }

  // ─── CTA hover ripple (subtle) ─────────────────────────────────
  function setupCtaRipple() {
    document.body.addEventListener('click', function (e) {
      var btn = e.target.closest('.pp-cta');
      if (!btn || btn.classList.contains('pp-cta--ghost')) return;
      var rect = btn.getBoundingClientRect();
      var ripple = document.createElement('span');
      ripple.className = 'pp-ripple';
      ripple.style.left = (e.clientX - rect.left) + 'px';
      ripple.style.top = (e.clientY - rect.top) + 'px';
      btn.appendChild(ripple);
      setTimeout(function () { ripple.remove(); }, 700);
    });
  }

  // ─── Variant picker (PDP) ──────────────────────────────────────
  function setupVariantPicker() {
    var pills = document.querySelectorAll('[data-pp-variant]');
    if (!pills.length) return;
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var available = pill.getAttribute('data-variant-available') === 'true';
        var id = pill.getAttribute('data-variant-id');
        var price = pill.getAttribute('data-variant-price');
        var unitTitle = pill.getAttribute('data-variant-title');

        // Update visual state
        pills.forEach(function (p) {
          p.classList.remove('is-selected');
          p.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('is-selected');
        pill.setAttribute('aria-checked', 'true');

        // Update price + unit
        var priceEl = document.querySelector('[data-pp-price]');
        var unitEl = document.querySelector('[data-pp-unit]');
        if (priceEl && price) priceEl.textContent = price;
        if (unitEl && unitTitle) unitEl.textContent = '/' + unitTitle;

        // Update Afterpay quarter amount
        if (price) {
          var num = parseFloat(price.replace(/[^0-9.]/g, ''));
          if (!isNaN(num)) {
            var quarter = num / 4;
            var formatted = '$' + (quarter % 1 === 0 ? quarter.toFixed(0) : quarter.toFixed(2));
            document.querySelectorAll('[data-pp-afterpay-amount]').forEach(function (el) {
              el.textContent = formatted;
            });
          }
        }

        // Update form variant id + button label/state
        var idInput = document.querySelector('[data-pp-variant-id]');
        var btn = document.querySelector('[data-pp-add-btn]');
        var btnLabel = document.querySelector('[data-pp-add-label]');
        if (idInput) idInput.value = id;
        if (btn) {
          btn.disabled = !available;
          btn.style.opacity = available ? '' : '0.55';
          btn.style.cursor = available ? '' : 'not-allowed';
        }
        if (btnLabel) {
          btnLabel.textContent = available ? ('Add to pantry - ' + price) : 'Coming soon';
        }

        // Swap gallery image for variants that have their own photo (e.g. Barkday cake colours)
        var vimg = pill.getAttribute('data-variant-img');
        if (vimg) {
          document.querySelectorAll('[data-pp-main-img]').forEach(function (im) {
            im.src = vimg;
            var vset = pill.getAttribute('data-variant-img-srcset');
            if (vset) im.srcset = vset;
          });
        }
      });
    });
  }

  function init() {
    autoTagReveals();
    setupReveals();
    setupQuickAdd();
    setupCtaRipple();
    setupVariantPicker();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ap-A0225FB4-C692-4859-AF48-5EB6BE210DF3 */
